import React, { useState, useEffect } from "react";
import { SectionItem } from "./SectionItem";
import { useSelector } from "react-redux";
import { getContent } from "../../../../utils/main";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { Banner } from "../../components/Banner";

export const Sections = () => {
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/turkmenistan/sections/`)
      .then((res) => {
        setSections(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, []);

  const controlCard = useAnimation();
  const [refCard, inViewCard] = useInView();
  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };
  const item = {
    visible: { opacity: 1, scale: 1 },
    hidden: { opacity: 0, scale: 0.5 },
  };
  useEffect(() => {
    if (inViewCard) {
      controlCard.start("visible");
    }
  }, [controlCard, inViewCard]);

  return (
    <div>
      <Banner />
      <div className="sections-wrapper mb-5">
        <div className="container-fluid">
          <div className="row welcome-sections-header">
            <div className="col-12">
              <h4>{getContent(content, "Sections header", lang)}</h4>
            </div>
          </div>
          {isLoading === true ? (
            "Loading..."
          ) : (
            <motion.div
              className="row"
              variants={list}
              ref={refCard}
              initial="hidden"
              animate={controlCard}
            >
              {sections.map((section) => (
                <motion.div
                  variants={item}
                  transition={{ duration: 0.5 }}
                  className="col-lg-3 col-md-4 col-sm-6 col-xs-12 section-item"
                >
                  <SectionItem
                    section={section}
                    sections={sections}
                    key={section.id}
                  />
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
};
